// extracted by mini-css-extract-plugin
module.exports = {"accordion":"styles_accordion__3BByM","contentWrapper":"styles_contentWrapper__Gupp4","content":"styles_content__Q3Aji"};